import { render } from "./CustomProcenaComponent.vue?vue&type=template&id=308393d8&scoped=true"
import script from "./CustomProcenaComponent.vue?vue&type=script&lang=js"
export * from "./CustomProcenaComponent.vue?vue&type=script&lang=js"

import "./CustomProcenaComponent.vue?vue&type=style&index=0&id=308393d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-308393d8"

export default script